import React, { Component } from 'react';
import Key from '../Key';
import {testKeyFromArr} from '../Key';

var keys = [
  'Й',
  'Ц',
  'У',
  'К',
  'Е',
  'Н',
  'Г',
  'Ш',
  'Щ',
  'З',
  'Х',
  'Ъ',
  'Ф',
  'Ы',
  'В',
  'А',
  'П',
  'Р',
  'О',
  'Л',
  'Д',
  'Ж',
  'Э',
  'Ё',
  'Я',
  'Ч',
  'С',
  'М',
  'И',
  'Т',
  'Ь',
  'Б',
  'Ю',
  ' ',
  '-'
]

var Keyboard = React.createClass({

  handleClick: function(data){
    this.props.actionSaveField(this.props.text + data)
  },
  handleErase: function(){
      this.props.actionSaveField(this.props.text.replace(/.$/, ''))
  },
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      console.log('nextProps.opperativeKey', nextProps.opperativeKey)
      if(nextProps.opperativeKey.keyCode == '8'){
        this.handleErase();
        return;
      }
      if(typeof nextProps.opperativeKey.key != 'undefined'){
        if(testKeyFromArr(nextProps.opperativeKey.key, keys)){
          this.handleClick(nextProps.opperativeKey.key)
        }
      }
      
    }
  },
  render: function(){
    if(!this.props.mobile){
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters">
            <Key actionClickButton={this.handleClick} val="Й" />
            <Key actionClickButton={this.handleClick} val="Ц" />
            <Key actionClickButton={this.handleClick} val="У" />
            <Key actionClickButton={this.handleClick} val="К" />
            <Key actionClickButton={this.handleClick} val="Е" />
            <Key actionClickButton={this.handleClick} val="Н" />
            <Key actionClickButton={this.handleClick} val="Г" />
            <Key actionClickButton={this.handleClick} val="Ш" />
            <Key actionClickButton={this.handleClick} val="Щ" />
            <Key actionClickButton={this.handleClick} val="З" />
            <Key actionClickButton={this.handleClick} val="Ф" />
            <Key actionClickButton={this.handleClick} val="Ы" />
            <Key actionClickButton={this.handleClick} val="В" />
            <Key actionClickButton={this.handleClick} val="А" />
            <Key actionClickButton={this.handleClick} val="П" />
            <Key actionClickButton={this.handleClick} val="Р" />
            <Key actionClickButton={this.handleClick} val="О" />
            <Key actionClickButton={this.handleClick} val="Л" />
            <Key actionClickButton={this.handleClick} val="Д" />
            <Key actionClickButton={this.handleClick} val="Ж" />
            <Key actionClickButton={this.handleClick} val="Х" />
            <Key actionClickButton={this.handleClick} val="Я" />
            <Key actionClickButton={this.handleClick} val="Ч" />
            <Key actionClickButton={this.handleClick} val="С" />
            <Key actionClickButton={this.handleClick} val="М" />
            <Key actionClickButton={this.handleClick} val="И" />
            <Key actionClickButton={this.handleClick} val="Т" />
            <Key actionClickButton={this.handleClick} val="Б" />
            <Key actionClickButton={this.handleClick} val="Ю" />
            <Key actionClickButton={this.handleClick} val="Э" />
            <Key actionClickButton={this.handleClick} val="Ь" />
            <Key actionClickButton={this.handleClick} val="-" />
            <Key actionClickButton={this.handleClick} probel="true" val=" " />
            <div className="button next" onClick={this.handleErase}>Стереть</div>
          </div>
        </div>
      );
    }else{
      // return(
      //   <div className="keyboardWrapper Numbers">
      //     <div className="Keyboard numbers">
      //       <div className="row">
      //         <div className="innerTable">
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Й" />
      //             <Key actionClickButton={this.handleClick} val="Ц" />
      //             <Key actionClickButton={this.handleClick} val="У" />
      //             <Key actionClickButton={this.handleClick} val="К" />
      //             <Key actionClickButton={this.handleClick} val="Е" />
      //             <Key actionClickButton={this.handleClick} val="Н" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Г" />
      //             <Key actionClickButton={this.handleClick} val="Ш" />
      //             <Key actionClickButton={this.handleClick} val="Щ" />
      //             <Key actionClickButton={this.handleClick} val="З" />
      //             <Key actionClickButton={this.handleClick} val="Х" />
      //             <Key actionClickButton={this.handleClick} val="Э" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Ф" />
      //             <Key actionClickButton={this.handleClick} val="Ы" />
      //             <Key actionClickButton={this.handleClick} val="В" />
      //             <Key actionClickButton={this.handleClick} val="А" />
      //             <Key actionClickButton={this.handleClick} val="П" />
      //             <Key actionClickButton={this.handleClick} val="Р" />

      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="О" />
      //             <Key actionClickButton={this.handleClick} val="Л" />
      //             <Key actionClickButton={this.handleClick} val="Д" />
      //             <Key actionClickButton={this.handleClick} val="Ж" />
      //             <Key actionClickButton={this.handleClick} val="Б" />
      //             <Key actionClickButton={this.handleClick} val="Ю" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Я" />
      //             <Key actionClickButton={this.handleClick} val="Ч" />
      //             <Key actionClickButton={this.handleClick} val="С" />
      //             <Key actionClickButton={this.handleClick} val="М" />
      //             <Key actionClickButton={this.handleClick} val="И" />
      //             <Key actionClickButton={this.handleClick} val="Т" />
      //           </div>
      //         </div>
      //       </div>
      //       <div className="row" style={{height: "16.666%"}}>
      //         <div className="innerTable">
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" style={{width: "15.9%"}}  val="Ь" />
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" style={{width: "34%"}} probel="true" val=" " />
      //           <div className="serviceClass button" onClick={this.handleErase}>Стереть</div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      return null
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/Letters/index.jsx
 **/